import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialState from './state';
import { TPerson } from '@/common/basis/types/database/tperson';

const slice = createSlice({
  name: 'person',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<TPerson.User | undefined>) => {
      state.user = action.payload;
    },
  },
});

export const { setUser } = slice.actions;

export default slice.reducer;
